import React from 'react';
export function WhiteCheck(_a) {
    var _b = _a.width, width = _b === void 0 ? '10' : _b, _c = _a.height, height = _c === void 0 ? '9' : _c;
    return (React.createElement("svg", { className: "WhiteCheck", width: width, height: height, viewBox: "0 0 10 9", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M1 4.43945L4 7.43945L9 1.43945", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
}
